import React, { FC } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { useTranslation } from 'app/lang';

import PersonalDataModal from '../../../../../../components/PersonalDataModal';
import { PERSONAL_DATA_MODAL_PARAM_KEY } from './constants';

import dictionary from './UserName.dictionary.json';

import styles from './UserName.module.scss';

type Props = {
  value?: string;
};

export const UserName: FC<Props> = ({ value }) => {
  const { t } = useTranslation();
  const { location, replace } = useHistory();
  const urlParams = new URLSearchParams(location.search);

  const isOpen = urlParams.has(PERSONAL_DATA_MODAL_PARAM_KEY);
  const onClose = () => replace({ search: '' });

  if (value) {
    return (
      <div className={styles.root}>
        {value}
      </div>
    );
  }

  return (
    <div className={styles.root}>
      <Link to={`?${PERSONAL_DATA_MODAL_PARAM_KEY}`}>
        {t(dictionary.linkText)}
      </Link>

      <PersonalDataModal title={t(dictionary.modalTitle)}
                         showModal={isOpen}
                         handleClose={onClose} />
    </div>
  );
};
